/**
 * External dependencies
 */
import Backbone from 'backbone';
import AppRouter from '~/appRouter';
import EventHub from '~/eventHub';
import Settings from '~/settings.js';
import getUtilsService from '~/services/utilsService';
//Variable that contains all the languages
window.isPersonal = false;
var languagearray = {

    "en": {
       "OptMenu1" : "Reports",
       "OptMenu2" : "Saved Reports",
       "OptMenu3" : "Users",
       "SubmenuOpt1" : "Add User",
       "SubmenuOpt2" : "Consult User",
       "SubmenuOpt3" : "Profiles",
       "FooterMenuOpt1" : "Home",
       "FooterMenuOpt2" : "Profile",
       "FooterMenuOpt3" : "Log Out",
    },
    'es' : {
      "FirstLoginTittle" : "Cambio de contraseña",
	  "FirstLoginSubTittle" : "Cambio de contraseña",
	  "FirstPasswordField" : "Nueva Contraseña",
	  "FirstPasswordFieldHover" : "Dig&iacute;te su Nueva Contrase&ntilde;a",
	  "FirstConfirmPasswordField" : "Confirmar Contraseña",
	  "FirstConfirmPasswordFieldHover" : "Confirme su Contrase&ntilde;a",
	  "ChangePswBtn" : "Cambiar contraseña",
	  "InputAPassword" : "Digite una contraseña",
    "InputAToken" : "Digite un token de autenticación a 2 pasos",
	  "SamePassword" : "Confirmar la contraseña es diferente a la contraseña",
	  "ValidPassword" : "La contraseña debe ser igual o mayor a 8 caracteres, igual o menor a 24 caracteres y tener al menos una minúscula, una mayúscula y un número.",
	  "FirstLoginPswdChangeSuccess": "Contraseña cambiada exitosamente",
    "ActivateTokenSuccess": "Autenticacion a 2 pasos habilitada",
	  "FirstLoginTimeout": "Tiempo de espera para cambiar la contraseña agotado. Cambie la contraseña dentro de los 10 minutos estipulados.",
    "Req2FATimeout": "Tiempo de espera para activar la autenticación a 2 pasos agotado. Active la autenticación a 2 pasos dentro de los 60 minutos estipulados.",
	  "OptMenuChangelog": "Versiones",
	  "ListVersionsTittle": "Versiones",
	  "ListUsersTittle" : "Lista de Usuarios",
      "DeleteUser" : "Eliminar Usuario",
	  "UserDeleted" : "Usuario Eliminado",
      "UserNotDeleted" : "Usuario no Eliminado",
	  "DeleteNews" : "Eliminar Noticia",
      "NewsNotDeleted" : "Noticia no Eliminada",
	  "NewsAttachedLink" : "Ver enlace adjunto",
	  "ShowMoreNews" : "Ver más",
	  "NewsPreview" : "Previsualización noticia",
	  "EditNewsbtn" : "Editar Noticia",
	  "EditNewsPreview" : "Previsualización noticia",
	  "SaveNewsbtn" : "Guardar Noticia",
	  "SaveEditNewsbtn" : "¿Realmente desea cambiar esta noticia?",
      "Charttittle" : "Gráfico General",
      "YearsRange" : "Rango de Años",
      "QuantReports" : "Cantidad de Reportes",
	  "ToastrAccept" : "Aceptar",
		"ToastrCancel" : "Cancelar",
      "Sunday" : "Domingo",//sin traducir
      "Monday" : "Lunes",//sin traducir
      "Tuesday" : "Martes",//sin traducir
      "Wednesday" : "Miércoles",//sin traducir
      "Thursday" : "Jueves",//sin traducir
      "Friday" : "Viernes",//sin traducir
      "Saturday" : "Sábado",//sin traduci
      "Januarylong" : "Enero",//sin traducir
       "Februarylong" : "Febrero",//sin traducir
       "Marchlong" : "Marzo",//sin traducir
       "Aprillong" : "Abril",//sin traducir
       "Maylong"  : "Mayo",//sin traducir
       "Junelong" : "Junio",//sin traducir
       "Julylong" : "Julio",//sin traducir
       "Augustlong" : "Agosto",//sin traducir
       "Septemberlong" : "Septiembre",//sin traducir
       "Octoberlong"  : "Octubre",//sin traducir
       "Novemberlong" : "Noviembre",//sin traducir
       "Decemberlong" : "Diciembre",
       "Monthrange" : "Rango de meses:",
       "January" : "Ene",//monthsof the year //sin traducir
       "February" : "Feb",//sin traducir
       "March" : "Mar",//sin traducir
       "April" : "Abr",//sin traducir
       "May" : "May",//sin traducir
       "June" : "Jun",//sin traducir
       "July" : "Jul",//sin traducir
       "August" : "Ago",//sin traducir
       "September" : "Sep",//sin traducir
       "October" : "Oct",//sin traducir
       "November" : "Nov",//sin traducir
       "December" : "Dic",//sin traducir
       "daysx" : ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
	   //admin categories
       "EnterAdminCategUser" : 'Elegir Usuario',////sin traducir
       "SaveCateAdminBtn" : "Guardar",////sin traducir
       "NoAdminforCateg" : "Sin Definir",////sin traducir
	   "ActivateCategory" : "Activar Categoría",//sin traducir
	   "Activatescategorymessage" : "Categoria Activada",//sin traducir
	   "Activatesnocategoriemessage" : "Categoria no Activada",//sin traducir
	   "ActivateSubCategory" : "Activar Subcategoría",//sin traducir
	   "Deactivatecategory" : "Desactivar Categoría",//sin traducir
	   "CategoryDeactivated" : "Categoría Desactivada",//sin traducir
	   "CategorynoDeactivated" : "Categoría no Desactivada",//sin traducir
	   "DeactivateSubcategory" : "Desactivar Subcategoría",//sin traducir
	   "SubcategoryDeactivated" : "Subcategoría Desactivada",//sin traducir
	   "SubCategorynoDeactivated" : "Subcategoría no Desactivada",//sin traducir
       "Errorpushnot" : "Por favor Llenar Los Dos Campos para Enviar Notificaciones.",//sin traducir
       "confirmsendpushnot" : "Por favor confirmar el envío de la notificación a todos los usuarios.",//sin traducir
       "confirmsendpushnotmessage" : "Se envío la notificación correctamente.",//sin traducir
	   "Errortroubleshooting" : "Por favor Llenar Los Dos Campos para Crear Ticket de Soporte.",//sin traducir
	   "confirmsendtroubleshooting" : "Ticket de Soporte creado satisfactoriamente.",//sin traducir
       "selnewreport" : "Nuevos",
       "selasginreport" : "Asignados",
       "selarchivereport" : "Archivados",
       "Asign" : "Categorías de Otros Reportes",
       "New" : "Categorías de reportes Nuevos",
       "Archive" : "Categorías de Reportes Archivados",
       "myreportstittle" : "Mostrando Mis reportes",
       "asigntittle2" : "Mostrando reportes Asignados",
       "newtittle2" : "Mostrando reportes Nuevos",
       "archivetittle2" : "Mostrando reportes Archivados",
       "NoFilestodiscard" : "No hay archivos para Descartar",
       "NoFilestosave": "No hay archivos para guardar",
       "Filetstosave":"Guardar Archivos",
       "Filetsnotsave":"Archivos no Guardados",
       "filesnotest":"Archivos de la nota: ",
       "AsignedReportMessage": "Reporte asignado correctamente",
       "PriorityReportMessage": "Reporte priorizado correctamente",
       "NoteFilestext" : "Archivos Adjuntos",
       "NoFilestoshow" : "No hay archivos que mostrar.",
       "LoadReport" : "Cargando reporte ",
       "messagetochangestatus": "Por favor indicar el motivo de cerrar el reporte:",
       "messagetochangestatus2": "Por favor indicar el motivo de descarte el reporte:",
       "messagetochangestatus3": "Por favor indicar el motivo de abrir el reporte:",
       "SaveStateok": "Estado guardado correctamente",
       "tableheaderrecive" : "Reportes Totales",
       "tableheadernew" : "Reportes Nuevos",
       "tableheaderclosed " :"Reportes Cerrados",
       "tableheaderdiscard" : "Reportes Descartados",
       "tableheaderassigned" : "Reportes Asignados",
       "generaltable": "General",
       "allcategories": "TODAS LAS CATEGORÍAS",
       "ShogunInform" : "Informe Shogun Monitor:",
       "Inform" : "Informe: ",
       "Numberreport" : "Número de Denuncia",
       "tabledate" : "Fecha",
       "tablecategory" : "Categoría",
       "tablesubcategory" : "Subcategoría",
       "tableuser" : "Usuario",
       "tabledatefirstresponse" : "Fecha y Hora de Primera Respuesta",
       "tablestate": "Estado de Denuncia",
       "tablereason" : "Motivo de Cierre",
       "tabledateclosediscard": "Fecha y Hora de Cierre o Descarte",
       "tableasign" : "Asignado",
       "tablepriority" :"Prioridad",
       "tabledescription" : "Descripción",
       "tablecomments" : "Comentarios",
       "Anonreport" : "Anónimo",
       "open" : "Abierto",
       "close" : "Cerrado",
       "discard" : "Descartado",
       "exporttable" : "Exportar Tabla",
       "exportreports" : "Exportar Reportes",
       "nopriority" : "Prioridad: Sin asignar",
       "lowpriority" : "Prioridad: Baja",
       "midpriority" : "Prioridad: Media",
       "highpriority" : "Prioridad: Alta",
       "newreporticon" : "Reporte Actualizado",
       "alertnewreports": "Hay Reportes Actualizados disponibles",
       "totalqtyreports":"Cantidad total de Reportes",
       "gotosupcateg": "Ir a la Categoría",
       "newreports" : "Reportes Actualizados",
       "warning" : "Advertencia",
       "warningmessage" : "Ya no es colaborador de este reporte.",
		"notifToday": "Hoy",
		"RemoveUser" : "Algunos reportes o categorías podrian quedarse sin colaboradores asignados. ¿Realmente desea eliminar este usuario?",
		"ChangeUserEmail" : "¿Realmente desea cambiar el correo de este usuario?",
		"ChangeUserUsername" : "¿Realmente desea cambiar el nombre de este usuario?",
		"ChangeUserRole" : "¿Realmente desea cambiar el role de este usuario?",
		"ChangeUserPswd" : "¿Realmente desea cambiar la contraseña de este usuario?",
		"DeleteLanguage": "Borrar lenguaje. Continuar?",
		"UserLimitExceeded": "Máximo de usuarios alcanzado.",
		"RemAllCollaboratorsReport": "El reporte actual dejaría de tener colaboradores asignados. ¿Realmente desea remover todos los colaboradores de este reporte?",
		"RemAllCollaboratorsSuperCat": "Los reportes de esta categoría podrian no tener colaboradores asignados. ¿Realmente desea remover todos los colaboradores de esta categoría?",
		"InternetConnectionError": "Problema de conexión con el servidor",
		"RecoverPasswordErrorMsg": "Ocurrió un error, intente más tarde.",
		"RecoverPasswordOkMsg": "Consulte su correo electrónico para restablecer su contraseña.",
		"LoginError": "Usuario o contraseña inválidos. Por favor intente de nuevo.",
		"ChatSendMessageError": "Error al ingresar comentario.",
		"SuperCategoryUpdateError": "Error al ingresar la categoría.",
		"NewSubCategoryError": "Error al ingresar la Subcategoría.",
		"NewSuperCategoryError": "Error al ingresar la categoría.",
		"DelUserInChargeReportError": "Reporte no asignado, hubo un problema con la red.",
		"NewRoleError": "Error al crear rol",
		"NewReportCommentError": "Error al ingresar comentario.",
		"NewLanguageError": "Error al agregar lenguaje.",
		"EditLanguageError": "Error al agregar lenguaje.",
		"DelLanguageError": "Error al agregar lenguaje.",
		"DeletedUser": "Usuario borrado",
		"DeleteRoleBtn": "Eliminar",
		"UserAssignedToRole": "Hay un usuario asociado al perfil",
		"DeleteRole": "¿Realmente desea eliminar este perfil?",
		"ChangeRole": "¿Realmente desea cambiar el nombre de este perfil?",
		"ValidRoleName" : "El nombre del perfil sólo puede tener caracteres alfanuméricos, _, - y espacios en blanco",
		"RoleNameNotSaved": "Error al cambiar el nombre de este perfil",
		"SameNameRole": "Existe otro perfil con el mismo nombre",
		"Adminnotitle": "Bitácora de denuncia",
		"RoleCreated": "Operación realizada",
		"RoleNotSaved": "Perfil no guardado correctamente, intenté de nuevo",
		"AdminNoteSeeMore": "Ver más",
		"tableadminnotes": "Bitácora de denuncia",
		"troubleContactSupport": "En caso de tener problemas con su inicio de sesión o perdida del token, por favor contactar al correo soporte@shogunmonitor.com",
		"ListSupportTicketsTittle": "Lista de Tickets de Soporte",
		"OptMenu7": "Soporte",
    "OptMenuSupport1": "Guías",
		"OptMenuSupport2": "Mis Tickets",
		"SupportTicketTittle": "Detalle del ticket #",
		"SupportTicketDate": "Fecha del ticket:",
		"SupportTicketDescriptionTittle": "Información del ticket",
		"SearchReportsError": "Error en la búsqueda de reportes",
		"ChnagePasswordError": "Error al cambiar la contraseña",
    "ActivateTokenError": "Error al activar la autenticación a 2 pasos",
		"tableheaderstatus": "Estado",
    "ChangeSubCatSucess": "Categoría cambiada satisfactoriamente",
    "ReportRelocateBtn": "Reubicar",
    "UserDesactivatedLoginError": "No puede iniciar sesión por que su usuario ha sido desactivado",
    "ActivateUserButton": "Activar Usuario",
		"DeactivateUserButton": "Desactivar Usuario",
		"ActivateUserQ": "¿Realmente desea activar este usuario?",
		"ActivateUserA": "Usuario activado correctamente",
		"DeactivateUserQ": "¿Realmente desea desactivar este usuario?",
		"DeactivateUserA": "Usuario desactivado correctamente",
    "AnalyticsPersonalizedFormsInfo": "Si desea tener detalle de los datos de los formularios personalizados de alguna categoría o subcategoria especifica, por favor filtre el gráfico con la categoría o subcategoría deseada.",
    "Discard": "Categorías de Reportes Descartados",
		"Close": "Categorías de Reportes Cerrados",
    "SubCatBadgeNoResponse": "Alerta de vencimiento de denuncia",
		"ReportBadgeNoResponse": "Alerta de vencimiento de denuncia",
    "SuperCatBadgeNoResponse": "Hay alertas de vencimiento de denuncia",
    "DeletedReportDataError": "Por buenas practicas de protección de datos de los usuarios, los datos del reporte han sido eliminados.",
		"SupportTicketComentsTittle": "Conversación con Soporte:",
		"TicketTittle": "Crear Ticket de Soporte",
		"TicketTittle2": "Ayuda",
		"troubleshootingTitle": "Título del problema",
		"troubleshootingContent": "Explique el problema",
		"TroubleFiles": "Adjuntar Archivos",
		"SendTroublebtn": "Enviar",
		"SendTicketError": "Error al enviar el ticket"
    },
    'pt' : {
       //report
       "AdminRole" : "Gestor",
       "InvesRole" : "Investigador",
       "AnonymousRole" : "Anónimo",
       "MainTittle" : "Categoría de relatorios",
       "DiscardReportHover" : "Descartar relatorios",
       "DetailsReportHover" : "Olhar detalhes do reporte",
       "ReportDetailTittle" : "Detalle de denuncia#",
       "ReportSubTittle" : "Detalhe",
       "ReportAnonUser" : "Anónimo",
       "ReportStatus1" : "Aberto",
       "ReportStatus2" : "Fechado",
       "ReportStatus3" : "Descartado",
       "ReportChangeStatusBtn" : "Mudar de estado",
       "ReportAssignBtn" : "Encomendar",
       "ReportDescriptionTittle" : "Descrição",
       "ReportAttachedFiles" : "Arquivos anexados:",
       "ReportComentsTittle" : "Coméntarios:",
       "ReportAdminComentsTittle" : "Coméntarios do Auditor:",
       "ReportCommentBtn" : "Comentar",
       "ReportNumber" : "Denuncia número",//sin traducir
       "ReportDate" : "Fecha de la denuncia",//sin traducir
       "ReportUserName" : "Nombre de Usuario",//sin taducir
       "ReportStatus" : "Estado de la denuncia",//sin traducir
       "ReportAsigne" : "Denuncia asignada a",//sin traducir
       "LoadReport" : "Cargando Reporte",//sintraducir
       ////admin notes
       "Adminnotest" : "Notas del Auditor",//sin traducir
       "AttachmentsText" : "Ver Archivos de la nota",//sin traducir
       "NewNote" : "Nueva Nota",//sin traducir
       "AttachFiles" : "Adjuntar Archivos",//sin traducir
       "Savebtn" : "Guardar Nota",//sin traducir
       "NoteFiles" : "Archivos de la Nota",//sin traducir
       "AttachFilestext" : "Archivos Adjuntos",//sin traducir
       "AttachFilesbtn" : "Adjuntar Archivos",//sin traducir
       "SaveFilesbtn2" : "Guardar Archivo/s",//sin traducir
       "NoFilestodiscard" : "No hay archivos para Descartar",//sin traducir
       "NoFilestoshow" : "No hay archivos que mostrar",//sin traducir
       "NoFilestosave" : "No hay archivos para guardar",//sin traducir
       "Filetstosave" : "Guardar Archivos",//sin traducir
       "Filetsnotsave": "Archivos no Guardados",//sin traducir
       "NoteFilestext" : "Archivos Adjunto",//sin traducir
       //sidebar
       "OptMenu1" : "Reportes Nuevos",//sin traducir
       "OptMenu2" : "Reportes Asignados",//sin traducir
       "OptMenu3" : "Relatorios arquivados",
       "OptMenu4" : "Usuarios",
       "OptMenu5" : "Administrar Categorías",//sin traducir
       "OptMenu6" : "Gráficos",//sin traducir
       "SubmenuOpt1" : "Adicionar Usuarios",
       "SubmenuOpt2" : "Conferir Usuarios",
       "FooterMenuOpt1" : "Inicio",
       "FooterMenuOpt2" : "Perfil",
       "FooterMenuOpt3" : "Saida",
       "UserMenu1" : "Perfil",
       "UserMenu2" : "Saida",
       "Statisticsbtn" : "Estadísticas",//sin traducir
       "Days" : "Días",//sin traducir
       "Month" : "Mes",//sin traducir
       "Year" : "Año",//sin traducir
       "Monthsc" : "Meses:",//sin traducir
       "Yearsc" : "Años:",//sin traducir
       "Generalchart" : "General:",//sin traducir
       "Categorieschart" : "Categorías:", //sin traducir
       "Subcategoriechart" : "Subcategorías:",//sin traducir
       "Cleanfilters" : "Limpiar Filtros",//sin traducir
       "Dofilters" : "Aplicar",//sin traducir
       "January" : "Ene",//monthsof the year //sin traducir
       "February" : "Feb",//sin traducir
       "March" : "Mar",//sin traducir
       "April" : "Abr",//sin traducir
       "May" : "May",//sin traducir
       "June" : "Jun",//sin traducir
       "July" : "Jul",//sin traducir
       "August" : "Ago",//sin traducir
       "September" : "Sep",//sin traducir
       "October" : "Oct",//sin traducir
       "November" : "Nov",//sin traducir
       "December" : "Dic",//sin traducir
       "Januarylong" : "Enero",//sin traducir
       "Februarylong" : "Febrero",//sin traducir
       "Marchlong" : "Marzo",//sin traducir
       "Aprillong" : "Abril",//sin traducir
       "Maylong"  : "Mayo",//sin traducir
       "Junelong" : "Junio",//sin traducir
       "Julylong" : "Julio",//sin traducir
       "Augustlong" : "Agosto",//sin traducir
       "Septemberlong" : "Septiembre",//sin traducir
       "Octoberlong"  : "Octubre",//sin traducir
       "Novemberlong" : "Noviembre",//sin traducir
       "Decemberlong" : "Diciembre",//sin traducir
       "Monthrange" : "Rango de meses:",//sin traducir
       "Sunday" : "Domingo",//sin traducir
       "Monday" : "Lunes",//sin traducir
       "Tuesday" : "Martes",//sin traducir
       "Wednesday" : "Miércoles",//sin traducir
       "Thursday" : "Jueves",//sin traducir
       "Friday" : "Viernes",//sin traducir
       "Saturday" : "Sábado",//sin traducir
       //admin categories
       "AdminCategoryTittle" : "Administrar Categorías",//sin traducir
       "AdminCategoriesSubTittle" : "Seleccionar una Categoría",//sin traducir
       "AdminDeactivatedCategories" : "Categorías Desactivadas",//sin traducir
       "AdminCategoriesOpts" : "Opciones",//sin traducir
       "AdminSubCategoiresbtn" : "Administrar Subcategorías",//sin traducir
       "AdminDeactivateCategories" : "Desactivar Categoría",//sin traducir
       "AdminNewCategorie" : "Crear Nueva Categoría",//sin traducir
       "AdminAtivateCategorie" : "Activar Categoría",//sin traducir
       "AdminNewCategorietittle" : "Nueva Categoría",//sin traducir
       "Newcategoriename" : "Nombre de Nueva Categoría:",//sin traducir
       "Newcategoriepref" : "Prefijo para la Nueva Categoría:",//sin traducir
       "Savenewcategorie" : "Guardar Nueva Categoría",//sin traducir
       "AdminSubCategoriesSubtittle" : "Seleccionar una Subcategoría",//sin traducir
       "AdminSubCategoriesSubtittle2" : "Subcategorías Desactivadas",//sin traducir
       "AdminSubCategoriesOptbtn" : "Opciones",//sin traducir
       "AdminSubCategoriesDeactivatebtn" : "Desactivar Subcategoría",//sin traducir
       "AdminSubCategoiresCreatesubcat" : "Crear Nueva Subcategoría",//sin traducir
       "AdminSubCategoiresActivatedSubcat" : "Activar Subcategoría",//sin traducir
       "AdminSubCategoiresoutbtn" : "Salir",//sin traducir
       "AdminSubCategoiresnewsubcat" : "Nueva Subcategoría",//sin traducir
       "AdminSubCategoiresnewsubcatname" : "Nombre de Nueva Subcategoría:",//sin traducir
       "AdminSubCategoiressavenewsubcat" : "Guardar Nueva Subcategoría",//sin traducir
       "ActivateCategory" : "Activar Categoría",//sin traducir
       "Activatescategorymessage" : "Categoria Activada",//sin traducir
       "Activatesnocategoriemessage" : "Categoria no Activada",//sin traducir
       "Selectcategoriemsg" : "Seleccionar una Categoría para Activarla",//sin traducir
       "Selectsubcattoactivate" : "Seleccionar una Subcategoría para Activarla",//sin traducir
       "Activatesubcategorie" : "Activar Subcategoría",//sin traducir
       "Subcategorieactivated" : "Subcategoría Activada",//sin traducir
       "Subcategorienoactivated" : "Subcategoría no Activada",//sin traducir
       "SelectCategorietodeactivated" : "Seleccionar una Categoría para Desactivarla",//sin traducir
       "Deactivatecategory" : "Desactivar Categoría",//sin traducir
       "CategoryDeactivated" : "Categoría Desactivada",//sin traducir
       "CategorynoDeactivated" : "Categoría no Desactivada",//sin traducir
       "SelectSubCategorietodeactivated" : "Seleccionar una Subcategoría para Desactivarla",//sin traducir
       "DeactivateSubcategory" : "Desactivar Subcategoría",//sin traducir
       "SubcategoryDeactivated" : "Subcategoría Desactivada",//sin traducir
       "SubCategorynoDeactivated" : "Subcategoría no Desactivada",//sin traducir
	   "SelectCategorietoseeadmin" : "Seleccionar una Categoría para administrarla",//sin traducir
       "SelectCategorietoseesubcategories" : "Seleccionar una Categoría para ver sus Subcategorías",//sin traducir
       "Subcateogiresfor" : "Subcategorías para:",//sin traducir
       "Categoriewithnosubcategoires" : "Esta Categoría no tiene Subcategorías",//sin traducir
       "Pleaseentersubcatname" : "Por favor ingresar un nombre a la nueva Subcategoría",//sin traducir
       "Pleaseentercatname" : "Por favor ingresar un nombre a la nueva Categoría",//sin traducir
       "Pleaseentercatprename" : "Por favor ingresar un Prefijo a la nueva Categoría",//sin traducir
       "ProfileTittle" : "Perfil de Usuario",//sin traducir
       "UserNameField" : "Usuario",
       "UserEmailField" : "Email",
       "ProfileChangePasswordBtn" : "Trocar senha",
       "DochangesHoverBtn" : "Aceitar mudanças",
       "NoChangesHoverBtn" : "Não fazer Mudanças",
       "UserGetEmail" : "Recebir Correios:",
       "CreateUserTittle" : "Criar Usuario",
       "ListUsersTittle" : "Lista de Usuarios",//SIN TRADUCIR!!!!!!!!!
       "UserRoleFiled" : "Rol:",
       "UserPasswordFiled" : "Senha:",
       "CreateUserBtn" : "Criar",
       "ActionsforUsers" : "Ações",
       "DeleteUser" : "Eliminar",
       "LoginTittle" : "Acceso Administrativo",
       "LoginEmailField" : "Correio Electrónico",
       "LoginPasswordField" : "Senha",
       "LoginEmailFieldHover" : "Entre seu correio electrónico",
       "LoginPasswordFieldHover" : "Digite su Contraseña",
       "LoginBtn" : "Ingresar",
       "LoginRecoverPasswordBtn" : "Recuperar Contraseña",
       "LoginError" : "Usuario o contraseña inválidos. Por favor intente de nuevo.",
       "RecoverPasswordModalTittle" : "Ingrese su Correo Electrónico",
       "RecoverPasswordBtn": "Recuperar Contraseña",
       "RecoverPasswordBackBtn" : "Volver",
       "RecoverPasswordOkMsg": "Consulte su correo electrónico para restablecer su contraseña",
       "RecoverPasswordErrorMsg": "Ocurrió un error, intente más tarde",
       "DiscardReportMessage" : "Reporte Descartado",
       "AsignedReportMessage" : "Reporte asignado correctamente",
       "SaveStateok" : "Estado guardado correctamente",
       "UsersEmailField" : "Coreo",
       "UserCreated" : "Usuario Creado",
       "messagetochangestatus" : "Por favor indicar el motivo de cerrar el reporte:",//sin traducir
       "messagetochangestatus2" : "Por favor indicar el motivo de descartar el reporte:", // sin traducir
       "messagetochangestatus3" : "Por favor indicar el motivo del cambio de estado del reporte.",//sin traducir
       "Charttittle" : "Gráfico General",//sin traducir
       "QuantReports" : "Cantidad de Reportes",//sin traducir
       "YearsRange" : "Rango de Años",//sin traducir
       "Reasonofchangestate" : "Motivo de cierre",//sin traducir
       "daysx" : ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sabado'],//sin traducir
       "SaveCateAdminBtn" : "Guardar",//sin traducir
       "EnterAdminCategUser" : 'Elegir Usuario',//sin traducir
       "NoAdminforCateg" : "Sin Definir",////sin traducir
       "SaveCateAdminBtn" : "Guardar",////sin traducir
       "OptMenupushnot " : "Enviar Notificaciones",//sin traducir
       "pushnotTittle" : "Título de la Notificación:",//sin traducir
       "SendPushNotbtn" : "Enviar",//sin traducir
       "Errorpushnot" : "Por favor Llenar Los Dos Campos para Enviar Notificaciones.",//sin traducir
       "sendpushnotsTittle" : "Enviar Notificaciones a los Usuarios",//sin traducir
       "confirmsendpushnot" : "Por favor confirmar el envío de la notificación a todos los usuarios.",//sin traducir
       "confirmsendpushnotmessage" : "Se envío la notificación correctamente.",//sin traducir
       "CreateProfileTittle": "Perfiles",
       "CreateRoleBtn": "Nuevo",
       "newroleTittle": "Nuevo Rol",
       "ActionsforRole" : "Acciones",
       "DeleteRole": "Eliminar",
       "Newrolename": "Nombre del Rol:",
       "RoleCreated": "Rol creado",
       "Rolenew": "Nuevo Rol",
       "RoleEdit": "Editar Rol",
       "AdminSubCategoireschangename":"Cambiar nombre Subcategoría",
       "AdminSubCategoiresnewnamesubcat": "Nuevo nombre Subcategoría",
       "AdminSubCategoiresnewnamesubcatname": "Nuevo nombre Subcategoría",
       "AdminSubCategoiressavenewnamesubcat":"Guardar",
    }
};
window.arrlang = languagearray;
//Variable thath indicates the app language
window.lang= 'es';

window.mobilelangkeys = [
    "AcceptBtn",
    "AccepttermsSubtittle",
    "AccepttermsSubtittle2",
    "AttachBtn",
    "Attachfilesreport",
    "BackBtn",
    "Btn_back",
    "Btn_home",
    "Btn_NewsBack",
    "CheckAttachedFile",
    "CheckboxText",
    "Comment_send",
    "Conferencistas_conferencistas",
    "ConsultBtn",
    "CreateCommentPlaceHolder",
    "CreateCommentThks",
    "CreateCommentThksMessage",
    "CreateCommentTittle",
    "CreateReport",
    "DescPlaceHolder",
    "Descriptionmsg",
    "Filetolarge",
    "Home_Conferencistas",
    "Home_News",
    "Home_Patrocinadores",
    "Home_Programa",
    "InfoText",
    "InfoText2",
    "InfoText3",
    "InsertDetailsReportTittle",
    "inputsearchcode",
    "LocalizationModalTittle",
    "MainTittle",
    "MakeQuestionClapfo",
    "Modal2btn",
    "MyReportsBtn",
    "MyReportsModalInfo",
    "MyReportsModalTittle",
    "NewReportBtn",
    "NewReportForCat",
    "News_news",
    "OptionalText",
    "Placeholder-home",
    "PushNews",
    "PushRepTitle",
    "PushSeeMore",
    "PushSeeReport",
    "ReportActivity",
    "ReportCommentAdmin",
    "ReportCommentAnonymous",
    "ReportCommentsTittle",
    "ReportDays1",
    "ReportDays2",
    "ReportDescription",
    "ReportDetailSubTittle",
    "ReportDetailTittle",
    "ReportNewComment",
    "ReportStatus1",
    "ReportStatus2",
    "ReportStatus3",
    "search",
    "SelectCategory",
    "Selectprogram",
    "SendBtn",
    "Singlenews_singlenews",
    "SubsidiaryBtn",
    "Termnstittle",
    "ThksInfo",
    "ThksTittle",
    "UserNameReportHolder",
    "WarningTittle"
];

window.UrlExists=function (url)
{
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    return http.status!=404;
};

window.spinnerDialog = {};
window.spinnerDialog.show = function(message){
  $('#loader').show();
  if(message == undefined){
    message = "";
  }
  $('#loader .message').html(message);
};

window.spinnerDialog.hide = function(){
  $('#loader').hide();
};

var serverData = {
  id: Settings.parseAppId, url: Settings.parseUrl
};
localStorage.setItem('serverdata', JSON.stringify(serverData));

setInterval(function(){
	var user = Parse.User.current();
  var permissions = getUtilsService.getprofilepermissions();
  var params = {};
  if (Settings.shogunmonitorapp && !permissions.accessallreports) {
    params.shogunmonitorapp = true;
  };
	Parse.Cloud.run("getroles", params).then((roles) => {
		for (var i = 0; i < roles.length; i++) {
			if (roles[i].attributes.name == user.attributes.role) {
				localStorage.setItem('permissions', JSON.stringify(roles[i].attributes.permissions));
			}
		}
	}).catch((e) => {
    if(e.code == 209){
      getUtilsService.handleInvalidSession();
    }
  });
}, 20000);

// Getting the app router
var appRouter = new AppRouter();
// Setting it to a window object
window.appRouter = appRouter;
// Initialising the Backbone history handler
Backbone.history.start();
// Starting up the navigation event
EventHub.on('navigate', (fragment, options) => {
    appRouter.navigate(fragment, options);
});
